import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { AuthService } from './auth.service';
import { User } from '@app/models';
import { Observable, from, map, of } from 'rxjs';
import { sortNestedTree } from '@app/helpers/sort-nested-tree';

@Injectable({
  providedIn: 'root'
})
export class UsersGroupsService {
  private groups: any[] = [];
  private groupsTree: any[] = [];
  private users: any[] = [];

  constructor(private apiService: ApiService, public authService: AuthService) {}

  getGroupsTree(): Observable<any[]> {
    if(this.groupsTree.length!==0){
      return of(this.groupsTree);
    }
    return from(this.apiService.getFromURL('/api/v1/groups', {flat_list:false, simple: true})).pipe(
      map((wPlaces: any) => {
        let groups = wPlaces.groups?.map((place: any) => {
          return {
            ...place,
            disabled: false
          };
        });
        const sortByKey = 'name';
        this.groupsTree = sortNestedTree(groups, sortByKey);
        return this.groupsTree;
      })
    );
  }

  getGroups(): Observable<any[]> {
    if(this.groups.length!==0){
      return of(this.groups);
    }
    return from(this.apiService.getFromURL('/api/v1/groups', {flat_list:true})).pipe(
      map((wPlaces: any) => {
        this.groups = wPlaces.groups?.map((place: any) => {
          return {
            ...place,
            disabled: false
          };
        });
        return this.groups;
      })
    );
  }

  getUsers(): Observable<any[]> {
    if(this.users.length!==0){
      return of(this.users);
    }
    return from(this.apiService.getFromURL('/api/v1/users', {flat_list:true})).pipe(
      map((users: any) => {
        this.users = users.users;
        return this.users;
      })
    );
  }

  /**
   * Clears all cached data in the service.
   * Should be called during logout to prevent data leakage between sessions.
   */
  clearCache(): void {
    this.groups = [];
    this.groupsTree = [];
    this.users = [];
  }
}
